import {
    ILoadCasesFilterSuccessAction, IStoreSFSuccessAction,
} from '../actions/load-cases';
import { IChannelCareState } from '../state';

export const filterSuccessReducer = (state: IChannelCareState, action: ILoadCasesFilterSuccessAction) => ({
    ...state,
    cases: {
        ...state.cases,
        filter: action.data
    }

})

export const storeFilterSuccessReducer = (state: IChannelCareState, action: IStoreSFSuccessAction) => ({
    ...state,
    selectedFilters: action.data
})
